<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space clickabe" @click="msgAlerta=null">
        <span class="text">{{ msgAlerta }}</span>
    </div>


    <div v-show="!modoEdicao">
        <div class="form-edit-page row row-space">
            <div class="form-item-rangedata"><DateRangeSelect :periodoInicial="'currentMonth'" v-model="dateRange" /></div>
            <div class="form-item">
                <EquipamentoFrame v-model:objSelecionado="equipSelecionado" />
            </div>

            <button type="button" class="buttom-icon--search" @click="lerDados" />
            <button type="button" class="buttom-icon--add" @click="novoCadastro" />
            <button type="button" class="buttom-icon--close" @click="closeForm" />
        </div>


        <div v-if="lsDados.length>0" class="table-wrapper"><table>
            <thead><tr>
                <th>Execução</th>
                <th>KM/Horas</th>
                <th>Equipamento</th>
                <th>Serviço</th>
                <th>Manual</th>
                <th>Status</th>
            </tr></thead>
            
            <tbody><tr v-for="(obj, index) in lsDados" :key="obj.id" @click="editarCadastro(obj)" 
                :class="{'even-row': index % 2 === 0, 'odd-row': index % 2 !== 0, 'clickabe-row': true}">
                    <td class="col-width-char10 center">{{ Funcoes.formatDateFromJson(obj.dtexecucao) }}</td>
                    <td class="col-width-char10 right">{{ Funcoes.formatDecimal(obj.kmhoras, 1) }}</td>
                    <td>{{ obj.nmequipamento }}</td>
                    <td class="col-width-char50">{{ obj.nmservico }}</td>
                    <td class="col-width-char10 center">{{ obj.ckavulsa }}</td>
                    <td class="col-width-char10 center">{{ obj.dhestorno ? 'Estornado' : 'Normal' }}</td>
            </tr></tbody>
        </table></div>


        <div v-if="showPagination" class="pagination">
            <button :disabled="currentPage === 1" class="buttom-pagination--first" @click="currentPage=1; updatePaginatedData();" />
            <button :disabled="currentPage === 1" class="buttom-pagination--prior" @click="currentPage--; updatePaginatedData();" />
            <div class="field-label field-label-center">{{ currentPage }} de {{ Math.ceil(lsDadosMain.length / itemsPerPage) }}</div>
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--next" @click="currentPage++; updatePaginatedData();" />
            <button :disabled="currentPage === Math.ceil(lsDadosMain.length / itemsPerPage)" class="buttom-pagination--last" @click="currentPage = Math.ceil(lsDadosMain.length / itemsPerPage); updatePaginatedData();" />
        </div>
    </div>


    <div v-show="modoEdicao">
        <div class="form-edit-page">
            <div class="row row-space">
                <div class="form-item">
                    <EquipamentoFrame :initId="idEquipInicial" v-model:idSelecionado="objEdicao.idequipamento" />
                </div>
            </div>

            
            <div class="row row-space">
                <div class="form-item">
                    <ManutServicoFrame :initId="idServicoInicial" v-model:idSelecionado="objEdicao.idservico" />
                </div>

                <div class="form-item-data">
                    <label class="label-caption">Data</label>
                    <input type="date" v-model="objEdicao.dtexecucao" />
                </div>
                
                <div class="form-item-char15">
                    <label class="label-caption">KM/Horas</label>
                    <input v-model="objEdicao.kmhoras" v-decimal type="text" class="input-right" />
                </div>
            </div>


            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Observações:</label>
                    <textarea v-model="objEdicao.obs" maxlength="5000" rows="3" style="resize: none;"/>
                </div>
            </div>


            <div class="row-end">
                <button type="button" class="btn-small btn-cancel" @click="modoEdicao=false">Voltar</button>
                <button v-if="objEdicao.id>0" type="button" class="btn-small btn-delete" @click="estornarRegistro">Excluir</button>
                <button type="button" class="btn-small btn-save" @click="salvarDados">Salvar</button>
            </div>
        </div>


        <div v-if="lsManutencoes.length>0" class="form-panel mt-md">
            <div class="form-panel-header">LISTA SERVIÇOS DO PLANO DE MANUTENÇÃO</div>
            <div class="form-panel-body">
                <div class="cards-container">
                    <div v-for="(item, index) in lsManutencoes" :key="index" class="card">
                        <h3 class="card-title">{{ item.nmservico }}</h3>
                        <div class="card-body">
                            <div class="card-field">
                                <span class="label">Última KM:</span>
                                <span class="value">{{ Funcoes.formatDecimal(item.kmultima) ?? '-' }}</span>
                            </div>
                            <div class="card-field">
                                <span class="label">Última Data:</span>
                                <span class="value">{{ Funcoes.formatDateFromJson(item.dtultima) ?? '-' }}</span>
                            </div>
                            <div class="card-field">
                                <span class="label">Próxima KM:</span>
                                <span class="value">{{ Funcoes.formatDecimal(item.kmproxima) }}</span>
                            </div>
                            <div class="card-field">
                                <span class="label">Próxima Data:</span>
                                <span class="value">{{ Funcoes.formatDateFromJson(item.dtproxima) }}</span>
                            </div>
                            <div class="card-field vencido" v-if="item.ckvencido === 'S'">
                                ⚠️ Vencido
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <ModalJustificativaTexto ref="modalJustificativa" />
</template>


<script setup>
import { onMounted, nextTick, ref, watch } from 'vue';
import { Api } from '@/funcoes/apiExport.js';
import { criarManutExecucao } from '@/models/ManutExecucao';
import { Funcoes } from '@/funcoes/utils';
import { globalStore } from '@/globals';
import { Validar } from '@/funcoes/validacoes';
import DateRangeSelect from '@/components/DateRangeSelect.vue';
import EquipamentoFrame from '@/components/frames/EquipamentoFrame.vue';
import ManutServicoFrame from '@/components/frames/ManutServicoFrame.vue';
import ModalJustificativaTexto from '@/components/modals/ModalJustificativaTexto.vue';

const emit = defineEmits(['close']);

const dateRange = ref({ startDate: "", endDate: "", selectedPeriod: "" });
const msgAlerta = ref(null);
const isLoading = ref(false);
const isLoadingHistorico = ref(false);
const lsDados = ref([]);
const lsManutencoes = ref([]);
const modalJustificativa = ref(null);
const modoEdicao = ref(false);

const objEdicao = ref(criarManutExecucao());
const equipSelecionado = ref(null);

const currentPage = ref(1);
const itemsPerPage = ref(globalStore.itensPorPagina);
const lsDadosMain = ref([]);
const showPagination = ref(false);


const idEquipInicial = ref(0);
const idServicoInicial = ref(0);


function closeForm() {emit('close');}


function editarCadastro(obj) {
    setEdicao(obj.id);
}


async function estornarRegistro(){
    const rModal = await modalJustificativa.value.show();
    if (!rModal.confirmado) return;

    try {
        msgAlerta.value=null;
        isLoading.value = true;
        const r = await Api.genericPut('/cad/manut_execucao', {
            id: objEdicao.value.id,
            lgestorno: globalStore.idlogin,
            obsestorno: rModal.justificativa,
        });
        if (r.bolok === 1) {
            await lerDados();
            modoEdicao.value = false;
        }else{
            msgAlerta.value = r.erro;
        }
    } catch (error) {
        msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {
        isLoading.value = false;
    }
}


async function lerDados() {
    try{
        msgAlerta.value = null;
        isLoading.value = true;
        const req = await Api.genericPost('/frota/manut_execucao', {
            idmunicipio: globalStore.idmunicipio,
            idequipamento: equipSelecionado.value?.id,
            datainicial: dateRange.value.startDate,
            datafinal: dateRange.value.endDate,
            tipo: 1, // SELECIONA APENAS MARCADAS COMO CKAVULSA = 'S'
        });
        lsDadosMain.value = req;
        currentPage.value=1;
        showPagination.value = (lsDadosMain.value.length > itemsPerPage.value);
        updatePaginatedData();
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {isLoading.value = false;}
}


async function salvarDados() {
    msgAlerta.value = validarDados();
    if (msgAlerta.value) return;
    try {
        isLoading.value = true;
        objEdicao.value.kmhoras = Funcoes.decimalFromString(objEdicao.value.kmhoras);
        const response  = await Api.genericPut('/cad/manut_execucao', objEdicao.value);
        if (response.bolok === 1){
            await lerDados();
            modoEdicao.value = false;
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally {isLoading.value=false;}
}


async function setEdicao(idEdicao) {
    try{
        isLoading.value = true;
        msgAlerta.value       = null;
        if (idEdicao > 0) {

            idEquipInicial.value=-1;
            idServicoInicial.value=-1;
            await nextTick();

            const req = await Api.getCadastroById('manut_execucao', idEdicao);
            Object.assign(objEdicao.value, req[0]);

            idEquipInicial.value = objEdicao.value.idequipamento;
            idServicoInicial.value = objEdicao.value.idservico;
        }else{
            objEdicao.value = criarManutExecucao();
            objEdicao.value.idmunicipio = globalStore.idmunicipio;
        }
        objEdicao.value.idlogin = globalStore.idlogin;
        modoEdicao.value = true;
    } catch (error){msgAlerta.value = `ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`;
    } finally {isLoading.value=false;}
}


async function novoCadastro() {
    idEquipInicial.value=-1;
    idServicoInicial.value=-1;
    await nextTick();
    
    idEquipInicial.value=0;
    idServicoInicial.value=0;
    setEdicao(0);
}


function updatePaginatedData() {
    const startIndex = (currentPage.value - 1) * itemsPerPage.value;
    const endIndex = (startIndex + itemsPerPage.value);
    lsDados.value = lsDadosMain.value.slice(startIndex, endIndex);
}


function validarDados(){
    let x = '';
    let r = Validar.numeroPositivo(objEdicao.value.idequipamento, '\n-Informe o equipamento');
    if (!r.ok) x += r.msg;
    r = Validar.numeroPositivo(objEdicao.value.idservico, '\n-Informe o serviço');
    if (!r.ok) x += r.msg;
    r = Validar.data(objEdicao.value.dtexecucao, -9999, '\n-Data de execução');
    if (!r.ok) x += r.msg;
    r = Validar.numeroPositivo(objEdicao.value.kmhoras, '\n-Informe valor de KM ou Horas');
    if (!r.ok) x += r.msg;
    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}


watch(
    () => objEdicao.value.idequipamento,   // fonte reativa
    async (novoValor, valorAntigo) => {    // callback
        if (novoValor && novoValor !== valorAntigo) {
            try {
                isLoadingHistorico.value = true;
                const reqManutencoes = await Api.genericPost('/frota/manutencao/status', {
                    idmunicipio: globalStore.idmunicipio,
                    idequipamento: novoValor});
                lsManutencoes.value = reqManutencoes || [];
            } catch (error){console.log(`ATENÇÃO: Não foi possível acessar dados do servidor: "${error.message}"`);
            } finally {isLoadingHistorico.value = false;}
        } else {
            lsManutencoes.value = [];
        }
    }
)


onMounted(lerDados);
</script>


<style scoped>
.cards-container {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 1rem;
}

.card {
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 1rem;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    transition: transform 0.2s ease;
}

.card:hover {
    transform: translateY(-4px);
}

.card-title {
    font-size: 1.1rem;
    font-weight: bold;
    margin-bottom: .8rem;
    color: #333;
}

.card-body {
    display: flex;
    flex-direction: column;
    gap: .4rem;
}

.card-field {
    display: flex;
    justify-content: space-between;
    font-size: .95rem;
}

.card-field .label {
    font-weight: 600;
    color: #555;
}

.card-field .value {
    color: #222;
}

.vencido {
    margin-top: .6rem;
    color: #b00020;
    font-weight: bold;
}
</style>